import { render, staticRenderFns } from "./keyProjectComplete.vue?vue&type=template&id=525656fe&scoped=true&"
import script from "./keyProjectComplete.vue?vue&type=script&lang=js&"
export * from "./keyProjectComplete.vue?vue&type=script&lang=js&"
import style0 from "./keyProjectComplete.vue?vue&type=style&index=0&id=525656fe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525656fe",
  null
  
)

export default component.exports